import {prom_validate_ps_push_data} from "./src/utils/psPushUtils";

$(function(){

    //Personal information
    if($('.view.form.person_contact_sheet_form').length > 0 && $('.view.form.person_contact_sheet_form button.btn.btn-default.control.next.pull-right').length > 0){
        var $updateBtn = $('.view.form.person_contact_sheet_form button.btn.btn-default.control.next.pull-right');
        
        $updateBtn.off('click');
        
        $updateBtn.on('click', function(e){
            e.stopPropagation();
            e.preventDefault();
            
            var form = new adapt.form($(this).parents('form').get(0));
            var $pages = $(this).parents('form').find('.form_page');
            var valid = true;
            
            for(var i = 0; i < $pages.length; i++){
                if (!form.is_page_valid($($pages.get(i)))) {
                    valid = false;
                }
            }
            
            if (valid){
                //Remove old ps errors
                if ($('.ps-validate-errors').length > 0) {
                    $('.ps-validate-errors').slideToggle("fast", function(){
                        $(this).remove();
                    });
                }
                
                form = $(this).parents('form');
                let form_data = form.serializeArray();
                let data = {};
                
                $(form_data).each(function(index, obj){
                    data[obj.name] = obj.value;
                });
        
                prom_validate_ps_push_data(data).then(function(res) {

                    if ($('.ps-validate-errors').length > 0) {
                        $('.ps-validate-errors').slideToggle("fast", function(){
                            $(this).remove();
                        });
                    }
        
                    if(res === false){
                        if(psPushErrorsArr !== null){
                            let errorsAlert = '<div class="ps-validate-errors" style="display:none;"><br><div class="alert alert-danger">';

                            for(let err in psPushErrorsArr){
                                if(typeof psPushErrorsArr[err].propertyNameInAts !== 'undefined' && typeof psPushErrorsArr[err].errorMessage !== 'undefined'){
                                    errorsAlert += '<p> - <b>' + psPushErrorsArr[err].propertyNameInAts + '</b> : ' + psPushErrorsArr[err].errorMessage + '</p><br>';
                                    form.find("[name='" + psPushErrorsArr[err].propertyNameInAts + "']").parents('.form-group').addClass('has-error');
                                }
                            }
                            errorsAlert+= "</div></div>";
                            
                            $(errorsAlert).prependTo(form).slideToggle("fast");

                            $("html, body").animate({ scrollTop: 0 });
                        }
                    }
                    else
                    {
                        if ($('.ps-validate-errors').length > 0) {
                           $('.ps-validate-errors').slideToggle("fast", function(){
                            $(this).remove();
                           });
                        }
                        
                        $("html, body").animate({ scrollTop: 0 });
                        form.find('.view.form_page').slideToggle("fast", function(){
                            form.off('submit').trigger('submit');
                            $('<div style="text-align: center; display: none;"><h3>Saving... please wait</h3><i class="fa fa-gear fa-spin fa-5x"></i><br></div>').appendTo(form).slideToggle("fast");
                        });
                    }
                    return res;
    
                });
            }else{
                if ($(".has-error").first().hasClass("form_page_section_field")) {
                    $('html, body').animate({
                        scrollTop: $(".has-error").first().parent().offset().top
                    }, 500);
                } else {
                    $('html, body').animate({
                        scrollTop: $(".has-error").first().parent().parent().offset().top
                    }, 500);
                }
            }
            
        });
    }

    //Application
    $('.manual-apply-button').parents('form').on('submit', function(e){
        e.stopPropagation();
        e.preventDefault();

        let form = $(this);
        let form_data = form.serializeArray();
        let data = {};
        $(form_data).each(function(index, obj){
            data[obj.name] = obj.value;
        });

        prom_validate_ps_push_data(data).then(function(res) {      

            if ($('.ps-validate-errors').length > 0) {
               $('.ps-validate-errors').remove();
            }

            if(res === false){   
                if(psPushErrorsArr !== null) {
                    // show errors on top of modal 
                    let errorsAlert = '<br class="ps-validate-errors"><div class="ps-validate-errors alert alert-danger">';
                    // loop and publish errors
                    for(let err in psPushErrorsArr) {
                        if(typeof psPushErrorsArr[err].propertyNameInAts !== 'undefined' && typeof psPushErrorsArr[err].errorMessage !== 'undefined'){
                            errorsAlert += '<p> - <b>' + psPushErrorsArr[err].propertyNameInAts + '</b> : ' + psPushErrorsArr[err].errorMessage + '</p><br>';
                        }
                    }
                    errorsAlert+= '</div>';

                    form.prepend(errorsAlert);
                    $("html, body").animate({ scrollTop: 0 });
                }
                
                form.find('.manual-apply-button').attr("disabled", false).html('Apply for this position');
                return false;
            }

            if ($('.ps-validate-errors').length > 0) {
               $('.ps-validate-errors').remove();
            }
            
            $('button[class="manual-apply-button"]').attr("disabled", true).html('Sending application... Please wait');
            form.off('submit').trigger('submit');
        });
    });
});